import React, { useState } from 'react';
import { motion } from 'framer-motion';
import samplePdf from '../pdf/Nutritional Modulation of Hemostasis Dietary strategies for Vascular Health.pdf'; // replace with your real PDF

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const ReviewArticlePdfPage = () => {
  const [pdfToView, setPdfToView] = useState(null);

  const awardData = [
    {
      id: 1,
      title: 'Optimising Brain Health: Lifestyle Interventions Based on Evidence',
      pdf: samplePdf, // replace with actual PDF path
    },
  ];

  return (
    <>
      <motion.div
        className="article-section-pm"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.h2 className="article-heading-pm" variants={itemVariants}>
          <span className='impact-word-highlight'>IMPACT</span> OFFERS TO PUBLISH
        </motion.h2>
        <motion.div className="article-cards-pm" variants={containerVariants}>
          {awardData.map((item) => (
            <motion.div className="article-card-pm review-article" key={item.id} variants={itemVariants}>
              <h3>{item.title}</h3>
              <button
                onMouseMove={(e) => {
                  const button = e.currentTarget;
                  const rect = button.getBoundingClientRect();
                  button.style.setProperty('--x', `${e.clientX - rect.left}px`);
                  button.style.setProperty('--y', `${e.clientY - rect.top}px`);
                }}
                onClick={() => setPdfToView(item.pdf)}
              >
                <span>View PDF</span>
              </button>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>

      {/* PDF Modal */}
      {pdfToView && (
        <div
          className="pdf-modal-overlay"
          onClick={() => setPdfToView(null)}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.8)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div
            className="pdf-modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              width: '90%',
              height: '90%',
              background: '#fff',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 0 20px rgba(0,0,0,0.2)'
            }}
          >
            <button
              onClick={() => setPdfToView(null)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '30px',
                fontSize: '24px',
                background: 'none',
                border: 'none',
                color: '#fff',
                cursor: 'pointer',
                zIndex: 10,
              }}
            >
              &times;
            </button>
            <iframe
              src={`${pdfToView}#toolbar=0`}
              title="PDF Viewer"
              style={{ width: '100%', height: '100%', border: 'none' }}
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default ReviewArticlePdfPage;
